import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../models/User';
import { displayImg } from '../../utils/utils.functions';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrl: './default-header.component.scss',
})
export class DefaultHeaderComponent implements OnInit {
  user: User;
  textButton = 'Se connecter';
  textHeader = 'Vous avez déjà un compte ?';
  onboarded = false;
  statusLoaded = false;
  constructor(private router: Router, public authService: AuthService) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.textButton = router.url.includes('login')
          ? "S'inscrire"
          : 'Se connecter';
        this.textHeader = router.url.includes('login')
          ? "Vous n'avez pas encore de compte ?"
          : 'Vous avez déjà un compte ?';
      }
    });
    // this.textButton =  router.url.includes('register') ? "S'inscrire" : 'Se connecter'
  }

  onClick(): void {
    if (this.router.url.includes('login')) {
      this.router.navigate(['/agency/register']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit(): void {
    if (this.router.url != '/login') {
      this.authService.getUser().subscribe((value) => {
        this.user = value;
      });
    }
    this.authService.onboardingStatus().subscribe({
      next: (res: any) => {
        this.onboarded = !!res?.onboarded;
        this.statusLoaded = true;
      },
      // Fail-open on error so a flaky status endpoint can't hide the only
      // entry point to a legitimate first onboarding.
      error: () => {
        this.onboarded = false;
        this.statusLoaded = true;
      },
    });
  }

  /**
   * On the login page the "S'inscrire" CTA stays hidden until we know the
   * instance is NOT yet onboarded (no flash). The "Se connecter" CTA shown on
   * other pages is unaffected.
   */
  get showAuthCta(): boolean {
    if (this.router.url.includes('login')) {
      return this.statusLoaded && !this.onboarded;
    }
    return true;
  }

  protected readonly displayImg = displayImg;
}
